<section class="container ">
  <a class="btn btn-blue ml-2" (click)="openModal()">افزودن فایل</a>

  <section *ngIf="documents?.length">
    <div class="col-12">
      <app-pagination [total]="total" [limit]="limit" (page)="load($event)"></app-pagination>
    </div>

    <section class="">
      <div class="row flex-row  kp-card" *ngFor="let document of documents;let i=index">
        <div class="col-12">
          <header class="fs-sm f-gray">
            {{document.RegisterTime|pdate}}
            <span class="float-left">{{document.Price|number}} تومان</span>
          </header>
          <a [routerLink]="['/document',document.Id]" target="_blank">
            <h3>{{document.Title}}</h3>
          </a>
          <div class="wrap" [innerHTML]="document.Description"></div>
          <div *ngIf="document.File">
            <i class="fa fa-file" [attr.content-type]="document.File.ContentType"></i>
            <div style="direction: ltr">{{document.File.Title}} [{{Utility.fileSize(document.File?.ContentLength)}}]
            </div>
            <button type="button" class="btn" title="دانلود فایل" (click)="download(document.Id)"><i
                class="fa fa-download"></i></button>
          </div>
        </div>

        <div class="alert-tag draft" *ngIf="!document.IsDownloadable && !document.IsSaleable">پیش‌نویس</div>
        <div class="alert-tag succeed" *ngIf="document.IsDownloadable && document.IsSaleable">منتشر شده</div>
        <div class="alert-tag" *ngIf="!document.IsDownloadable && document.IsSaleable">پیش‌فروش</div>
        <div class="alert-tag warning" *ngIf="document.IsDownloadable && !document.IsSaleable">توقف فروش</div>

        <div class="btn-group">
          <button class="btn btn-blue" type="button" (click)="openModal(document)">ویرایش</button>
          <button class="btn btn-red" type="button" (click)="delete(document.Id)">حذف</button>
        </div>
      </div>
    </section>
  </section>
</section>

<ngx-smart-modal #documentModal identifier="documentModal">
  <ngx-spinner name="action" [fullScreen]="false" type="timer"></ngx-spinner>
  <form (submit)="documentForm.valid && save()" #documentForm="ngForm">
    <div class="form-group">
      <input type="text" name="title" required placeholder="عنوان فایل" [(ngModel)]="selected.Title">
    </div>
    <div class="form-group">
      <input type="number" inputmode="numeric" name="price" required placeholder="قیمت به تومان" [(ngModel)]="selected.Price">
    </div>
    <div class="form-group">
      <textarea rows="6" name="description" placeholder="توضیحات" [(ngModel)]="selected.Description"></textarea>
    </div>

    <div class="d-flex mb-3">
      <input type="radio" name="file" [(ngModel)]="changeFile" value="none" />فایل وجود ندارد
    </div>
    <div class="d-flex mb-3" *ngIf="selected.File">
      <input type="radio" name="file" [(ngModel)]="changeFile" value="old" />
      <i class="fa fa-file"></i>
      فایل فعلی <div style="direction: ltr">{{selected.File.Title}} [{{Utility.fileSize(selected.File.ContentLength)}}]
      </div>
    </div>
    <div class="d-flex mb-3">
      <input type="file" #fileInput placeholder="انتخاب فایل جدید" (change)="file=fileInput.files[0]"
        style="display:none;">
      <input type="radio" name="file" [(ngModel)]="changeFile" value="new" (click)="fileInput.click()" />
      <i class="fa fa-file"></i>
      فایل جدید <div style="direction: ltr" *ngIf="file">{{file.name}} [{{Utility.fileSize(file.size)}}]</div>
    </div>

    <h3 class="pt-3">وضعیت انتشار</h3>
    <div class="form-group group-box">
      <label>
        <input type="checkbox" name="saleable" [(ngModel)]="selected.IsSaleable">
        <span>فایل قابل فروش است</span>
      </label>
      <label>
        <input [disabled]="!file && !selected.File" type="checkbox" name="downloadable"
          [(ngModel)]="selected.IsDownloadable">
        <span>فایل قابل دانلود است</span>
      </label>
    </div>

    <div class="cross-validation-error-message alert alert-danger"
      *ngIf="documentForm.invalid && (documentForm.touched || documentForm.dirty)">
      لطفا در وارد کردن فیلدهای مورد نظر را دقت فرمایید
      <!-- {{form.controls.description.errors}} -->
    </div>
    <button class="btn btn-yellow w-100" type="submit" [disabled]="documentForm.invalid">ارسال درخواست</button>
  </form>
</ngx-smart-modal>